import { atomWithStorage } from 'jotai/utils';

import { STORAGE_KEYS } from '@/atoms/storageKeys';

export interface Country {
  id?: string;
}

/** Runtime source of truth for stored/native appearance preference. */
export const COLOR_MODE_PREFERENCES = ['system', 'light', 'dark'] as const;

export type ColorModePreference = (typeof COLOR_MODE_PREFERENCES)[number];

export const isColorModePreference = (
  value: unknown,
): value is ColorModePreference =>
  typeof value === 'string' &&
  COLOR_MODE_PREFERENCES.some(preference => preference === value);

export interface UserPrefs {
  country: Country;
  language: string;
  theme: ColorModePreference;
}

export const userPrefsAtom = atomWithStorage<UserPrefs>(
  STORAGE_KEYS.USER_PREFS,
  {
    country: {},
    language: '',
    theme: 'light',
  },
  undefined,
  { getOnInit: true }, // sync atom on first read to avoid possible default theme light->dark flash
);
